import { type RegistryWidgetsType, type RJSFSchema } from '@rjsf/utils'
import { type ParametersFormContext } from '../formContext'
import { type JsonObject } from '../mergePatch'
import { CheckboxWidget } from './widgets/CheckboxWidget'
import { SelectWidget } from './widgets/SelectWidget'
import { TextareaWidget } from './widgets/TextareaWidget'
import { TextWidget } from './widgets/TextWidget'
import { ZocksReferenceWidget } from '../referenceWidgets/ZocksReferenceWidget'

export const parameterWidgets: RegistryWidgetsType<JsonObject, RJSFSchema, ParametersFormContext> = {
  zocksReference: ZocksReferenceWidget,
  SelectWidget,
  CheckboxWidget,
  TextWidget,
  TextareaWidget,
}
